import { Variants } from "framer-motion";
import transitions from "@styles/design-tokens/09.transitions/transitions";

export const ThumbnailButtonSelectedAnimation: Variants = {
  default: {
    width: "60px",
    transform: "translateY(0px)",
    margin: "0 auto",
    transition: {
      ease: transitions.timingFunctions["in-out-quart"],
      duration: 0.3,
    },
  },
  noneSelected: {
    width: "60px",
    transform: "translateY(0px)",
    margin: "0 auto",
    opacity: 0.5,
    transition: {
      ease: transitions.timingFunctions["in-out-quart"],
      duration: 0.3,
    },
  },
  selected: {
    width: "70px",
    transform: "translateY(-5px)",
    transition: {
      ease: transitions.timingFunctions["in-out-quart"],
      duration: 0.3,
    },
  },
};

export const ThumbnailButtonSelectedMobileAnimation: Variants = {
  default: {
    width: "40px",
    transform: "translateY(0px)",
    margin: "0 auto",
    transition: {
      ease: transitions.timingFunctions["in-out-quart"],
      duration: 0.3,
    },
  },
  noneSelected: {
    width: "40px",
    transform: "translateY(0px)",
    margin: "0 auto",
    opacity: 0.5,
    transition: {
      ease: transitions.timingFunctions["in-out-quart"],
      duration: 0.3,
    },
  },
  selected: {
    width: "50px",
    transform: "translateY(-5px)",
    opacity: 1,
    transition: {
      ease: transitions.timingFunctions["in-out-quart"],
      duration: 0.3,
    },
  },
};
